import { ReservationChanged } from 'utils/reservationWrites';

/**
 * Runs the write of an undo (a toast's revert) and tells staff when it did not
 * happen: `changed` with the German ReservationChanged message when its
 * expectation no longer held (someone changed the reservation since, so
 * nothing was written), `failed` when the write itself failed. Never rejects:
 * nobody awaits a toast's revert.
 */
export function reportUndo(
  write: Promise<boolean | void>,
  notify: { changed: (message: string) => void; failed: (error: unknown) => void }
): Promise<void> {
  return write.then(
    (applied) => {
      if (applied === false) notify.changed(new ReservationChanged().message);
    },
    (error) => notify.failed(error)
  );
}
